import { Component, OnInit,ElementRef, AfterViewInit,ViewChild, Input} from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { FormGroup, FormBuilder,FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AlertService,UserService } from '../_services/index';
declare let $: any;
declare let Ladda:any
import { DatePipe } from '@angular/common';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute,Params} from '@angular/router';
import { Helper } from '../_helpers/index';
import { config } from '../../config/acl';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-jsonupdate',
  templateUrl: './jsonupdate.component.html',
  styleUrls: ['./jsonupdate.component.css']
})

export class JsonUpdateComponent implements OnInit {
    data:any
    loading = false;
    backendUrl:any;
    model: any = {};
    id:number;
    time_zone:any;
    lang_value:any;
    show_branch: Boolean = true;
    type:any;
    token;
    rest_name:any;
    json_table:any;
    rest_id:any;
    column_name:any;
    table_name:any;
    json_value:any;
    branches:any;
    br_val:any;
    json_table_match:any;
    userData:any;
    br_id:any;
    rt_id:any=[];
    index_val : any;
    constructor(fb: FormBuilder,private http: Http,private datePipe: DatePipe,private userService:UserService,private router: Router,private activatedRoute: ActivatedRoute,private helper: Helper ,private translate:TranslateService)  { 
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));         
      let u_locale=currentUser.user_locale ? currentUser.user_locale: 'en_US';
      if (u_locale.indexOf("_")!= -1){
          let arr=u_locale.split('_'); 
              u_locale=arr[0];                    
          }
      else{
            u_locale='en';
          }
      this.translate.setDefaultLang(u_locale);
    }
    
     ngOnInit() {
       this.translate.get(['valid_requied','err_went_wrong','invalid_json','json_updated_successfully','json_invalid_restaurant']).subscribe(res => {
           this.lang_value=res;
        });
      var self = this;
      let url=window.location.hostname;
      this.token = localStorage.getItem('id_token');

      // if(url=='app.foodbot.ai' || url=='dashboard.foodbot.ai'){this.backendUrl=environment.prod}
      // else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
      // else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}  
      // else{ this.backendUrl=environment.local}
      if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
      else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
      else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
      else { 
        this.backendUrl=window.location.origin
        this.backendUrl+="/apis"
      }
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      let restaurant_id=currentUser.restaurant_id;
      this.time_zone = currentUser.time_zone ? currentUser.time_zone : 'America/Mexico_City';  

      this.userService.get_restaurant_name(this.backendUrl,JSON.stringify({'restaurant_id':restaurant_id}))
      .subscribe(data => {
        this.rest_name = data;
      });

      this.userService.get_json_table_data(this.backendUrl,JSON.stringify({'restaurant_id':restaurant_id}))
      .subscribe(data => {
        this.json_table = data;
      });

      this.userService.get_json_table_match_record(this.backendUrl,JSON.stringify({'restaurant_id':restaurant_id}))
      .subscribe(data => {
        this.json_table_match = data;
      });



    $(document).ready(function() {

      $.validator.addMethod("check_json", function(value, element) {
            try { 
                JSON.parse(value); 
                return true; 
            } catch (error) { 
                return false; 
            } 
      },self.lang_value.invalid_json);

        $('#jsonupdatedetails').validate({
            rules:{
                   restaurant_name:{required:true},
                   feature:{required:true},
                   feature_json_name: {required:true},
                   branch:{required:true},
                   json_val:{required:true},
                  },
            messages:{
                   restaurant_name:{required:self.lang_value.valid_requied},
                   feature:{required:self.lang_value.valid_requied},
                   feature_json_name: {required:self.lang_value.valid_requied},
                   branch:{required: self.lang_value.valid_requied},
                   json_val:{required: self.lang_value.valid_requied},
                },
            errorPlacement: function(error, element) {
                if (element.type == 'checkbox' || element.hasClass('select2') ) {
                    error.insertAfter(element.next('.select2-container'));
                } else {
                    error.insertAfter(element);
                }   
            }
        })
    });

 }

  get_restaurant_name(val_id){
  this.index_val = '';
  this.rest_id = val_id;
this.index_val= this.rt_id.indexOf(parseInt(val_id));
if(this.index_val == -1){
  $('#feature').val('');
    $('#feature_json_name').val('');
    $('#json_val').val('');
}
if(this.table_name != undefined && this.index_val == -1 && this.table_name == 'tr_restaurant_settings'){
 this.userService.get_tr_restaurant_settings_data(this.backendUrl,JSON.stringify({'restaurant_id':val_id,'table_name':this.table_name}))
      .subscribe(data => {
        // console.log(data);
        this.branches = data;
        if(data.length <= 0){
          $('#feature').val('');
      $('#feature').val('');
    $('#feature_json_name').val('');
        }
        $('#json_val').val('');
        $('#feature').val('');
    $('#feature_json_name').val('');
      });
      this.table_name = '';   
  }else{
    this.branches = [];
    $('#feature').val('');
    $('#feature_json_name').val('');
    $('#json_val').val('');
  }    
 }

 get_table_name(val){
  let id = '';
  this.rt_id = [];
  this.index_val = '';
  id = $('#feature').children(":selected").attr("id");
  this.br_id = id;
  let table_name = $('#feature').children(":selected").attr("class");
  let value = val.trim();
  this.table_name = table_name;

  this.userService.get_json_invalid_restaurant(this.backendUrl,JSON.stringify({'table_name':table_name}))
      .subscribe(data => {
        for(let i=0;i<data.length;i++){
        this.rt_id.push(data[i].restaurant_id)   
        }
        console.log(this.rt_id);
        if(id == 'No' || id == 'Yes'){
    console.log(this.rt_id,this.rest_id);
  this.index_val = this.rt_id.indexOf(parseInt(this.rest_id));
  console.log(this.index_val);
  if(this.index_val > -1){
    $('#error').html(this.lang_value.json_invalid_restaurant);
              $('#error').show();
                setTimeout(function(){
                    $('#error').hide();
                },5000);
  }
  $('#json_val').val('');
}
      });

   if(id == 'Yes' && this.table_name == 'tr_restaurant_settings'){ 
   this.userService.get_tr_restaurant_settings_data(this.backendUrl,JSON.stringify({'restaurant_id':this.rest_id,'table_name':this.table_name}))
      .subscribe(data => {
        this.branches = data;
      });  
    }
  if(id == 'Yes'){
    this.show_branch = true;
  }else{
    this.show_branch = false;
  }
this.userData = this.json_table_match.filter(
  item => {
      return value == item.json_table_id;    
    })
 }

 get_column_name(val_name){
  this.br_val = null;
  let sql = '';
  let data_val = {};
  let fetch_val = '';
  let currentUser = JSON.parse(localStorage.getItem('currentUser'));
  let restaurant_id=currentUser.restaurant_id;
  this.column_name = val_name;
  if(this.rest_id != undefined && this.table_name != undefined && this.br_id == 'No'){
  sql = "SELECT "+this.column_name+"  FROM "+this.table_name+" where restaurant_id=" + this.rest_id+"";  
  this.userService.get_json_records(this.backendUrl, JSON.stringify({ 'query': sql }))
      .subscribe(data => {
        data.map(function(key){
        Object.keys(key).map(function(keys_val) {
       data_val = $('.json_data_add').val(Object.values(data[0]));
       fetch_val = data_val[0].value;
      });
        })
      this.json_value = fetch_val;
      });
  }
 }

  get_branch(val){
    this.index_val = '';
  this.br_val = val;
  let sql = '';
  let data_val = {};
  let fetch_val = '';
  if(this.br_id == 'Yes'){
  this.index_val = this.rt_id.indexOf(parseInt(this.rest_id));
  if(this.index_val > -1){
    $('#error').html(this.lang_value.json_invalid_restaurant);
              $('#error').show();
                setTimeout(function(){
                    $('#error').hide();
                },5000);
  }
}
  if(this.column_name != undefined && this.table_name != undefined && this.rest_id != undefined  && this.br_id == 'Yes' && val != undefined){
  sql = "SELECT "+this.column_name+"  FROM "+this.table_name+" where restaurant_id=" + this.rest_id+" and branch_id="+this.br_val+"";  
  this.userService.get_json_records(this.backendUrl, JSON.stringify({ 'query': sql }))
      .subscribe(data => {
        data.map(function(key){
        Object.keys(key).map(function(keys_val) {
        data_val = $('.json_data_add').val(Object.values(data[0]));
        fetch_val = data_val[0].value;
      });
        })
      this.json_value = fetch_val;
      });
  }
 }

  keyDownFunction(event) {
    if (event.which == 13) {
      $('#savebtn').trigger('click');
    }
  }

saveJSONDetails()
{
  let json_obj_val = {};
  let currentUser = JSON.parse(localStorage.getItem('currentUser'));
  let restaurant_id=currentUser.restaurant_id;
  let user_id=currentUser.user_id;
  let date=new Date();
  let date_time = moment(date).format("YYYY-MM-DD HH:mm:ss");
  let json_val = $('#json_val').val();
  if($('#jsonupdatedetails').valid())
  {
    var l = Ladda.create( document.querySelector( '#savebtn' ) );
    l.start();
    if(this.index_val == -1){
    if(this.br_val){
     json_obj_val = {
      "column_table":this.table_name,
      "column_name":this.column_name,
      "json_value":json_val,
      "restaurant_id":this.rest_id,
      "branch_id":this.br_val
    }
    }else{
       json_obj_val = {
      "column_table":this.table_name,
      "column_name":this.column_name,
      "json_value":json_val,
      "restaurant_id":this.rest_id
    }
  }
    this.userService.update_json_records(this.backendUrl, JSON.stringify(json_obj_val))
      .subscribe(data => {
        if(data.success == '1'){
        $('#success').html(this.lang_value.json_updated_successfully);
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                           l.stop();
                    },3000);
        }
  })
    }else{
      $('#error').html(this.lang_value.json_invalid_restaurant);
              $('#error').show();
                setTimeout(function(){
                    $('#error').hide();
                    l.stop();
                },5000);
    }
}
}

}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/jsonupdate/jsonupdate.component.ts